import script from "./EmergencyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyModal.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyModal.vue?vue&type=style&index=0&id=0cb2ddd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb2ddd8"]])

export default __exports__